<template>
  <div
    v-if="Object.keys(itemData).length > 0 || isBorder"
    id="rightContentInfo"
    class="field-item-info scroll_bar_beautify_ff"
    :class="{'ant-drawer-open': visible}"
  >
    <i
      class="iconfont iconicon-test5 close-ico"
      @click="close"
    />
    <h2 class="field-item-tit">
      <span>{{ $t('message["44"]') }}</span> / {{ name }}
    </h2>
    <template>
      <template v-if="isBorder">
        <div class="field-item-row field-item-c-i">
          <div class="label">
            <!-- <em class="need-tip">*</em> -->
            {{ $t('message["1163"]') }}
          </div>
          <div class="field-item-cell">
            <!-- <a-input v-model="itemData.label" /> -->
            <a-form-item>
              <!-- <a-input
                v-decorator="[
                  'submit_text',
                  {
                    initialValue: deployDatas.config.submit_text
                  }
                ]"
                :placeholder="name"
                @change="getSumbitTxt"
              /> -->
              <a-input
                :value="deployDatas.config.submit_text"
                :placeholder="cloneLabel.label"
                @change="getSumbitTxt"
                @blur="setSubmitLabel"
              />
            </a-form-item>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="field-item-row field-item-c-i">
          <div class="label">
            <!-- <em class="need-tip">*</em> -->
            {{ $t('message["1653"]') }}
          </div>
          <div class="field-item-cell">
            <a-input
              :value="itemData.label"
              :placeholder="cloneLabel.label"
              @change="getLabel"
              @blur="setLabel"
            />
          </div>
        </div>
        <div
          v-if="type === 'area'"
          class="field-item-row"
        >
          <div class="label">
            {{ $t('message["1651"]') }}
          </div>
          <div class="field-item-cell">
            <a-radio-group v-model="itemData.fieldconfig.format">
              <a-radio :value="1">
                {{ $t('message["213"]') }}
              </a-radio>
              <a-radio :value="2">
                {{ $t('message["212"]') }}
              </a-radio>
              <a-radio :value="3">
                {{ $t('message["1317"]') }}
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="field-item-row field-item-c-i">
          <div class="label">
            {{ type !== 'file' ? 'placeholder' : $t('message["987"]') }}
          </div>
          <div class="field-item-cell">
            <a-input
              v-if="type !== 'area'"
              v-model="itemData.placeholder"
            />
            <div
              v-else
              class="area-placeholder clearfix"
            >
              <a-input
                v-if="format===1 || format===2"
                v-model="itemData.placeholder.select"
                class="area-area"
              />
              <a-input
                v-if="format===1 || format===3"
                v-model="itemData.placeholder.input"
                class="area-address"
              />
            </div>
          </div>
        </div>
        <default-value :item-data="itemData" />
        <template>
          <radio-c-s
            v-if="type === 'select' || type === 'radio' || type === 'checkbox'"
            :item-data="itemData"
          />
          <tree-item
            v-if="type==='select_tree'"
            :datas="itemData"
          />
        </template>
        <div class="field-item-row">
          <div class="field-item-cell">
            <span class="">{{ $t('message["1649"]') }}</span>
            <div class="field-need">
              <a-switch
                v-model="itemData.isneeded"
                :disabled="itemData.ishidden"
              />
            </div>
          </div>
        </div>
        <div class="field-item-row">
          <div class="field-item-cell">
            <span class="">{{ $t('message["1652"]') }}</span>
            <div class="field-need">
              <a-switch
                v-model="itemData.ishidden"
                :disabled="itemData.isneeded"
              />
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import eventBus from '@/lib/eventBus'
import DefaultValue from './fieldInfo/DefaultValue'
import RadioCS from './fieldInfo/RadioCS'
import TreeItem from './fieldInfo/TreeItem'
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  components: {
    DefaultValue,
    RadioCS,
    TreeItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  inject: ['myForm'],
  data () {
    return {
      itemData: {},
      cloneLabel: {},
      cloneBtnTxt: ''
    }
  },
  computed: {
    ...mapState('universalForm/form', ['infoDatas', 'formDefaultDatas', 'isBorder', 'deployDatas']),
    type () {
      return this.itemData.fieldtype
    },
    name () {
      let name = ''
      let { isBorder } = this
      if (isBorder) {
        name = this.$t('message["1162"]')
      } else {
        let { infoDatas, itemData } = this
        for (let key in infoDatas) {
          // 自定义字段child内返回的数据是对象不是数组
          if (infoDatas[key].child) {
            // infoDatas[key].child.forEach((listitem) => {
            for (let j in infoDatas[key].child) {
              let listitem = infoDatas[key].child[j]
              if (itemData.fieldkey === listitem.fieldkey) {
                name = listitem.fieldname
              }
            }
            // })
          }
        }
      }
      return name
    },
    format () {
      return this.itemData.fieldconfig.format
    }
  },
  created () {
    eventBus.$on('getItemData', (val) => {
      if (val === true) {

      } else {
        this.itemData = val
      }
      this.$emit('update:visible', true)
      this.cloneLabel = cloneDeep(val)
      this.cloneBtnTxt = cloneDeep(this.deployDatas.config.submit_text)
    })
    eventBus.$on('delItem', (datas) => {
      if (datas.fieldkey === this.itemData.fieldkey) {
        this.$emit('update:visible', false)
      }
    })
  },
  // mounted () {
  //   this.$nextTick(() => {
  //     let $main = document.getElementById('rightContentInfo')
  //     console.log($main)
  //     getH($main, 210)
  //   })
  // },
  methods: {
    close () {
      this.$emit('update:visible', false)
    },
    onChange (e) {
      this.itemData.ishidden = e
    },
    getLabel (e) {
      const label = e.target.value
      if (label !== '') {
        this.$set(this.itemData, 'label', label)
      } else {
        this.$set(this.itemData, 'label', '')
      }
    },
    setLabel (e) {
      if (!e.target.value) {
        this.$set(this.itemData, 'label', this.cloneLabel.label)
      }
    },
    getSumbitTxt (e) {
      const label = e.target.value
      if (label !== '') {
        this.deployDatas.config.submit_text = label
      } else {
        this.deployDatas.config.submit_text = this.name
        this.$set(this.deployDatas.config, 'submit_text', '')
      }
    },
    setSubmitLabel (e) {
      if (!e.target.value) {
        this.$set(this.deployDatas.config, 'submit_text', this.cloneBtnTxt)
      }
    },
    setFieldNeed (e) {
      this.itemData.isneeded = e
    }
  }
}
</script>
<style lang="scss" scoped>
.field-item-info::v-deep {
  width: 100%;
  overflow-y: auto;
  position: absolute;
  background: #fff;
  z-index: 4;
  top: 0;
  right: 0;
  transform: translateX(100%);
  padding: 24px;
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
  height: 100%;
  .close-ico {
    color: #d8d8d8;
    font-size: 16px;
    position: absolute;
    right: 24px;
    top: 24px;
  }
  .field-item-c-i {
    .ant-form-item {
      width: 100%;
    }
    .ant-form-item-control-wrapper {
      width: 100%;
    }
    .ant-input {
      width: 100%;
    }
  }
  .field-item-row {
    .label {
      display: block;
      line-height: 24px;
      padding: 4px 0;
    }
    .field-item-cell {
      line-height: 32px;
      position: relative;
      .field-need {
        position: absolute;
        right: 0;
        top: 0;
      }
      .field-item-inputs-cell {
        position: relative;
        padding: 8px 0;
        .ant-input {
          width: 320px;
        }
        .iconfont {
          color: #d8d8d8;
          font-size: 16px;
          position: absolute;
          right: 16px;
          display: none;
        }
        .iconicon-test8 {
          right: 48px;
        }
        .ant-checkbox-wrapper {
          margin-bottom: 0;
        }
      }
      .field-item-inputs-cell:hover {
        background: #f4f7f9;
        .iconfont {
          display: inline-block;
        }
      }
      .field-item-tip {
        em {
          color: #b3b3b3;
          font-style: normal;
        }
      }
      .date-picker {
        width: 320px !important;
        margin-right: 16px;
      }
      .need-tip {
        color: #f57676;
      }
      margin-bottom: 24px;
    }
  }
  .field-item-tit {
    span {
      color: #5077aa;
    }
    margin-bottom: 24px;
  }
}
.ant-drawer-open {
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
  width: 100%;
  transform: translateX(0);
}
.area-placeholder {
  .area-area {
    width: 200px !important;
    float: left;
    margin-right: 16px;
  }
  .area-address {
    width: 329px !important;
    float: left;
  }
}
</style>
